import { MedicineProduct } from './types';

export class MedicineProductsService {
  public static readonly medicineProductsApi = process.env.GATSBY_MEDICINE_API_URL;

  public static async getMedicineProducts(): Promise<MedicineProduct[]> {
    try {
      return fetch(this.medicineProductsApi)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Fetch error:', error);
      return [];
    }
  }
}
